import { and, asc, desc, eq } from "drizzle-orm";
import {
  type PowerSyncDrizzleDB,
  purchase_order,
  purchase_order_line,
  supplier,
} from "@comandero/powersync";
import {
  livePurchaseOrderFilters,
  livePurchaseOrderLineFilters,
  liveSupplierFilters,
} from "../live/filters";

/** Organization suppliers, by name. */
export function getSuppliersQuery(db: PowerSyncDrizzleDB, organizationId: string) {
  return db
    .select()
    .from(supplier)
    .where(and(eq(supplier.organization_id, organizationId), ...liveSupplierFilters()))
    .orderBy(asc(supplier.name));
}

/** Organization purchase orders, newest first. */
export function getPurchaseOrdersQuery(db: PowerSyncDrizzleDB, organizationId: string) {
  return db
    .select()
    .from(purchase_order)
    .where(and(eq(purchase_order.organization_id, organizationId), ...livePurchaseOrderFilters()))
    .orderBy(desc(purchase_order.created_at));
}

// ID-scoped (keyed) lookup: details by ID; viewing a deleted row is harmless.
export function getPurchaseOrderByIdQuery(db: PowerSyncDrizzleDB, purchaseOrderId: string) {
  return db.select().from(purchase_order).where(eq(purchase_order.id, purchaseOrderId)).limit(1);
}

/** Lines of a purchase order. */
export function getPurchaseOrderLinesQuery(db: PowerSyncDrizzleDB, purchaseOrderId: string) {
  return db
    .select()
    .from(purchase_order_line)
    .where(
      and(
        eq(purchase_order_line.purchase_order_id, purchaseOrderId),
        ...livePurchaseOrderLineFilters(),
      ),
    )
    .orderBy(asc(purchase_order_line.created_at));
}
